"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classNames = require("classnames");
var CardActions = function (_a) {
    var style = _a.style, className = _a.className, children = _a.children, _b = _a.align, align = _b === void 0 ? 'left' : _b;
    return (React.createElement("div", { "data-align": align, style: style, className: classNames(styles.cardActions, className, styles[align]) }, children));
};
exports.default = CardActions;
